export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "Как получить доступ?",
    a: "Аккаунты компаний создаёт только администратор платформы. Оставьте заявку в разделе «Контакты» — мы подключим вашу организацию.",
  },
  {
    q: "Какие форматы поддерживаются?",
    a: "Поддерживаются форматы DOCX и PDF.",
  },
  {
    q: "Сколько времени занимает обработка?",
    a: "От 1 до 10 минут в зависимости от размера документа.",
  },
  {
    q: "Можно ли настроить дизайн?",
    a: "Да, вы можете задать цвета, шрифты и логотип компании.",
  },
  {
    q: "Безопасны ли мои данные?",
    a: "Документы хранятся на защищённых серверах с шифрованием.",
  },
];
